import * as z from "zod";

import { additionalDataSchema } from "./additional-field";
import { surrealRecordSchema } from "./surreal-record";

export const apartmentSchema = surrealRecordSchema.extend({
  index: z.number(),
  objectNumber: z.string().optional(),
  streetNumber: z.string().optional(),
  apartmentNumber: z.string().optional(),
  floorNumber: z.string().optional(),
  area: z.number().optional(),
  share: z.number().optional(),
  additionalData: additionalDataSchema,
});

export const apartmentsSchema = z.array(apartmentSchema);

export type Apartment = z.infer<typeof apartmentSchema>;

export function getApartmentSchemaWithAdditionalFields(additionalFields: {
  apartment: typeof additionalDataSchema;
}): typeof apartmentSchema {
  return apartmentSchema.extend({
    ...(additionalFields.apartment && {
      additionalData: additionalFields.apartment,
    }),
  });
}
